
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FF4F00","fill-rule":"evenodd","d":"M17 3.515a1.6 1.6 0 0 0-1.6-1.6H2.6a1.6 1.6 0 0 0-1.6 1.6v12.8a1.6 1.6 0 0 0 1.6 1.6h12.8a1.6 1.6 0 0 0 1.6-1.6zm-2 9.4H3v3h12z","clip-rule":"evenodd"}})])
          )
        }
      }
    